import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  toasts: [],
  modals: {},
  loadingStates: {},
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    enqueueToast: (state, action) => {
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      state.toasts.push({
        id,
        severity: action.payload?.severity || 'info',
        message: action.payload?.message || 'Done',
      });
    },
    dismissToast: (state, action) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
    openModal: (state, action) => {
      const { key, data } = action.payload;
      state.modals[key] = data || true;
    },
    closeModal: (state, action) => {
      delete state.modals[action.payload];
    },
    setLoadingState: (state, action) => {
      const { key, isLoading } = action.payload;
      state.loadingStates[key] = Boolean(isLoading);
    },
    resetUiState: () => initialState,
  },
});

export const { enqueueToast, dismissToast, openModal, closeModal, setLoadingState, resetUiState } =
  uiSlice.actions;

export default uiSlice.reducer;
